export default {
  methods: {
    dynamicID() {
      return "input-" + Math.floor(Math.random() * Date.now().toString());
    }
  }
};
